import * as React from 'react';
import { IconChevronRight16 } from '@cian/ui-kit/icons';
import { UIHeading1 } from '@cian/ui-kit/typography';

import { Link } from '../Link';
import { VillageItem } from '../VillageItem';
import * as styles from './Villages.css';
import { Container } from '../Container';

export interface IVillage {
  id: number;
  name: string;
  priceDisplay: string;
  location: string;
  imageUrl: string;
  url: string;
}

interface IVillagesProps {
  villagesData: IVillage[];
  villagesLink: string;
}

export const Villages: React.FC<IVillagesProps> = ({ villagesData, villagesLink }) => {
  return (
    <Container dataName="Villages">
      <Link href={villagesLink} className={styles['title-container']}>
        <UIHeading1>Каталог коттеджных посёлков</UIHeading1>
        <div className={styles['arrow-icon']}>
          <IconChevronRight16 color="superblack_100" />
        </div>
      </Link>
      <div className={styles['villages-list']}>
        {villagesData.map((village, index) => {
          return <VillageItem village={village} key={`village_${index}`} />;
        })}
      </div>
    </Container>
  );
};
